// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3904":"854ed3578be29867","3980":"1ac5fa8f41df396d","5500":"ab575347fecc56b1"}[chunkId] + ".css";
};